import { Component, inject, OnInit, signal } from '@angular/core';
import { RegulatoryActivityListComponent } from '../../core/components/block/regulatory-activity-list/regulatory-activity-list.component';
import { ContainerComponent } from '../../core/components/block/container/container.component';
import { BreadCrumbsComponent } from '../../core/components/ui/bread-crumbs/bread-crumbs.component';
import { SearchInputComponent } from '../../core/components/block/search-input/search-input.component';
import {
  AppliedFilter,
  FilterOption,
  FiltersComponent,
} from '../../core/components/block/fitlers/filters.component';
import { PaginatorComponent } from '../../core/components/ui/paginator/paginator.component';
import { BreadCrumbService } from '../../core/services/bread-crumb.service';
import { IBreadCrumb } from '../../core/interface/bread-crumb';
import { PageModel } from '../../core/models/page.models';
import { ActivatedRoute, Router } from '@angular/router';
import { RegulatoryActivityService } from '../../core/services/regulatory-activity.service';
import { RegulatoryActivityModel } from '../../core/models/regulatory-activity.models';

@Component({
  selector: 'app-regulatory-activity',
  imports: [
    RegulatoryActivityListComponent,
    ContainerComponent,
    BreadCrumbsComponent,
    SearchInputComponent,
    FiltersComponent,
    PaginatorComponent,
  ],
  templateUrl: './regulatory-activity.component.html',
  standalone: true,
  styleUrl: './regulatory-activity.component.scss',
})
export class RegulatoryActivityComponent implements OnInit {
  page: PageModel | null = null;
  private router = inject(ActivatedRoute);
  private route = inject(Router);
  private breadCrumbService = inject(BreadCrumbService);
  private regulatoryActivityService = inject(RegulatoryActivityService);
  breadCrumb: IBreadCrumb[] = [
    { labels: ['Головна'], to: '/' },
    { labels: ['Плани регуляторної діяльності'], to: '/activity' },
  ];

  regulatoryActivity = signal<RegulatoryActivityModel[]>([]);

  filterOptions: FilterOption[] = [];
  appliedFilters: AppliedFilter[] = [];
  filter: Partial<RegulatoryActivityModel> = {};

  onFiltersChanged(filters: AppliedFilter[]): void {
    this.appliedFilters = filters;
    Object.keys(this.filter).forEach((key) => delete (this.filter as any)[key]);
    filters.forEach((f) => {
      (this.filter as any)[f.filterId] = f.value;
    });

    this.currentPage = 1;
    this.getList();
  }

  onSearch(query: string) {
    if (!query || !query.trim()) {
      delete this.filter.regulatorTitle;
    } else {
      this.filter.regulatorTitle = query.trim();
    }
    this.currentPage = 1;
    this.getList();
  }
  ngOnInit() {
    this.router.queryParams.subscribe((params) => {
      this.currentPage = Number(params['page']) || 1;
      this.getList();
    });
    this.router.data.subscribe((data) => {
      this.page = data['page'];
    });
    this.breadCrumbService.breadCrumbs.set(this.breadCrumb);
    this.updatePaginatedList();

    this.regulatoryActivityService
      .getAllRegulatorTitles()
      .subscribe((titles) => {
        this.filterOptions = [
          {
            id: 'regulatorTitle',
            label: this.page?.translation?.data?.filter1,
            options: titles.map((title) => ({ value: title, label: title })),
          },
          {
            id: 'dateScalePreset',
            label: this.page?.translation?.data?.filter6,
            options: [
              { value: 'last_week', label: 'Останній тиждень' },
              { value: 'last_month', label: 'Останній місяць' },
              { value: 'last_year', label: 'Останній рік' },
            ],
          },
        ];
      });
  }

  paginatedPrd: any[] = [];
  totalItems: number = 0;
  currentPage: number = 1;
  itemsPerPage: number = 8;

  onPageChange(page: number) {
    this.currentPage = page;
    this.filter.take = this.itemsPerPage;
    this.filter.skip = (this.currentPage - 1) * this.itemsPerPage;
    this.route.navigate([], {
      relativeTo: this.router,
      queryParams: { page },
      queryParamsHandling: 'merge',
    });
  }

  updatePaginatedList() {
    const start = (this.currentPage - 1) * this.itemsPerPage;
    const end = start + this.itemsPerPage;
    this.paginatedPrd = this.regulatoryActivity().slice(start, end);
  }
  getList() {
    this.filter.take = this.itemsPerPage;
    this.filter.skip = (this.currentPage - 1) * this.itemsPerPage;
    this.regulatoryActivityService.list(this.filter).subscribe({
      next: (data) => {
        this.paginatedPrd = data.data;
        this.totalItems = data.count;
        console.log('prd', data);
      },
    });
  }
}
